import * as React from 'react';

import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/BorderColorOutlined';
import { Fade, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import RecordList from "../components/RecordList";
import DeleteIconButton from '../components/DeleteIconButton';
import { useSnackbar } from 'notistack';
import { DataAPIContext, CREATE, UPDATE, GET_LIST, GET_ONE } from '../api';
import { NavigateBefore } from "@mui/icons-material";
import TemplatedMessagesMenuToolbar from './TemplatedMessagesMenuToolbar'
import TemplatedMessageTopicsMenu from './TemplatedMessageTopicsMenu'
import FormActionButtons from '../components/FormActionButtons';
import Autocomplete from '@mui/material/Autocomplete';
import axios from "axios";
import config from '../config';
import { reqConfig } from './utils/chat_utils';
import { ContextStore } from '../store/contextStore';
import { cv } from '../themeVars';

export default function TemplatedMessagesMenu(props) {
    const [isEditing, setIsEditing] = React.useState(false);
    const [msgBeingEdited, setMsgBeingEdited] = React.useState(null);
    const [isCreating, setIsCreating] = React.useState(false);
    const [isViewingTopics, setIsViewingTopics] = React.useState(false);
    const [query, setQuery] = React.useState("");
    const [APIFilters, setAPIFilters] = React.useState([]);
    const [selectedLanguageFilter, setSelectedLanguageFilter] = React.useState(null);
    const [selectedTopicFilter, setSelectedTopicFilter] = React.useState(null);
    const [topicInputValue, setTopicInputValue] = React.useState("");
    const [topicOptions, setTopicOptions] = React.useState([]);
    const [languages, setLanguages] = React.useState([]);
    const [relatedLoading, setRelatedLoading] = React.useState(false);
    const [isWaitingForAIResponse, setIsWaitingForAIResponse] = React.useState(false);
    const [state, setState] = React.useState(
        {
            templatedMessageText: "",
            templatedMessageTitle: "",
            templatedMessageLanguage: "",
            templatedMessageTopic: "",
            templatedMessageHasChangedSinceLastSave: false,
            templatedMessageIsSavable: false,
            numTemplatedMessages: 0,
            templatedMessagesList: [],
        });
    const { enqueueSnackbar } = useSnackbar();
    const dataAPI = React.useContext(DataAPIContext);
    const { hasPerm } = React.useContext(ContextStore);
    const canWriteTemplates = hasPerm('chat_template', 'write');
    const templated_chat_messages_list_resource = "templated_chat_messages_list";
    const resource = "templated_chat_messages";
    const refreshFromBackendFunc = React.useRef(null);
    const templateTextRef = React.useRef(null);
    const templateTextFieldRef = React.useRef(null);
    const templateTitleRef = React.useRef(null);
    const templateTitleFieldRef = React.useRef(null);
    const templateLanguageRef = React.useRef(null);
    const templateTopicRef = React.useRef(null);
    const initialAskToCloseTemplatedmessagesPaneKey = React.useRef(props.askToCloseTemplatedmessagesPaneKey);

    const showAISuggestionButton = props.participantsRoleDict[props.messages?.[props.messages.length - 1]?.author] === "Guest" && ["Sat Mexico", "Amigo Tours", "Crown Tours", "Fat Tire Tours", "Ciao Florence", "Babylon Tours"].includes(JSON.parse(window.localStorage.getItem('bootstrap'))?.tour_operator?.name);
    
    const checkHasChanged = () => {
        const hasChanges = (
            (isCreating &&  (!!templateTitleFieldRef.current?.value?.trim() || 
                            !!templateTextFieldRef.current?.value?.trim() || 
                            !!templateTopicRef.current?.trim() || 
                            (!!templateLanguageRef.current?.trim() && templateLanguageRef.current != props.subjectUserLanguage))
            ) ||
            (isEditing  && (msgBeingEdited.title !== templateTitleFieldRef.current?.value?.trim() ||
                            msgBeingEdited.text !== templateTextFieldRef.current?.value?.trim() ||
                            msgBeingEdited.topic !== templateTopicRef.current?.trim() ||
                            msgBeingEdited.language !== templateLanguageRef.current?.trim() )
            )
        )

        const isSavable = checkIsSavable();

        if(state.templatedMessageHasChangedSinceLastSave !== hasChanges){
            setState((prevState) => ({...prevState, templatedMessageHasChangedSinceLastSave: hasChanges}))
        }
        if(state.templatedMessageIsSavable !== isSavable){
            setState((prevState) => ({...prevState, templatedMessageIsSavable: isSavable}))
        }

        return hasChanges
    }

    const checkIsSavable= () => {
        const hasChanges = (
            (isCreating &&  !!templateTitleFieldRef.current?.value && 
                            !!templateTextFieldRef.current?.value && 
                            !!templateTopicRef.current && 
                            !!templateLanguageRef.current
            ) ||
            (isEditing  && !!templateTitleFieldRef.current?.value && 
                           !!templateTextFieldRef.current?.value &&
                           !!templateTopicRef.current &&
                           !!templateLanguageRef.current &&
                            (msgBeingEdited.title !== templateTitleFieldRef.current?.value ||
                            msgBeingEdited.text !== templateTextFieldRef.current?.value ||
                            msgBeingEdited.topic !== templateTopicRef.current ||
                            msgBeingEdited.language !== templateLanguageRef.current )
            )
        )
    
        return hasChanges
    }

    const handleClose = () => {
        if ((isEditing || isCreating) && checkHasChanged()){
            if(window.confirm('Are you sure you want to leave without saving changes?')){
                //setAnchorEl(null);
                setIsEditing(false);
                setIsCreating(false);
                props.closeTemplatedMessagesPane();
            }
        }
        else{
            //setAnchorEl(null);
            setIsEditing(false);
            setIsCreating(false);
            props.closeTemplatedMessagesPane();
        }
        
        /*setQuery(null);
        setState({
            templatedMessageText: "",
            templatedMessageTitle: "",
            templatedMessageLanguage: "",
            templatedMessageTopic: "",
            templatedMessageHasChangedSinceLastSave: false,
            numTemplatedMessages: 0,
            templatedMessagesList: [],
        });
        refreshFromBackendFunc.current = null;
        templateTextRef.current  = null;
        templateTextFieldRef.current  = null;
        templateTitleRef.current  = null;
        templateTitleFieldRef.current  = null;
        templateLanguageRef.current  = null;
        templateTopicRef.current  = null;
        setAPIFilters([])
        setSelectedLanguageFilter(null);
        setSelectedTopicFilter(null);
        setTopicInputValue("");*/
    };

    React.useEffect(() => {
        if(props.askToCloseTemplatedmessagesPaneKey != initialAskToCloseTemplatedmessagesPaneKey.current){
            handleClose();
        }
    }, [props.askToCloseTemplatedmessagesPaneKey]);

    const handleGoBack = () => {
        if ((isEditing || isCreating) && checkHasChanged()){
            if(window.confirm('Are you sure you want to leave without saving changes?')){
                setIsEditing(false);
                setIsCreating(false);
            }
        }
        else{
            setIsEditing(false);
            setIsCreating(false);
            setIsViewingTopics(false);
        }
    };

    const handleRowClick = (text) => {
        props.setTextAreaText(text);
        props.handleTypingChange();
        handleClose();
    }

    const populateTopics = async () => {
        // dataProvider reads pagination from the top level of its params arg.
        // This used to pass {params: {pagination: ...}} — one level too deep —
        // so the provider fell back to page_size 25 and the dropdown silently
        // dropped every topic past the first 25 (and the orphaned `params` key
        // leaked into the querystring as params=[object Object]).
        const res = await dataAPI(GET_LIST, 'templated_chat_message_topics_list', {
            pagination: { page: 1, perPage: 500 },
        });
        if (res.statusCode === 500) {
            console.error('populateTopics: error fetching templated_chat_message_topics_list');
        }
        console.log('populateTopics: data:', res.data)
        setTopicOptions(res.data)
    }
    
    const handleTemplatedMsgTopicSave = (topicTitle) => {
        if (!topicTitle || !topicTitle.trim()) {
            enqueueSnackbar("Templated message topic validation error", { variant: 'warning' });
            return
        }

        (async () => {
            try {
                const res = await dataAPI(CREATE, 'templated_chat_message_topics', {
                    data: {
                        topic_name: topicTitle,
                    }
                });

                if (res.statusCode === 200 || res.statusCode === 201) {
                    props.updateTemplatedMsgRefreshKey()
                    enqueueSnackbar("Templated message topic saved", { variant: 'success' });
                } else if (res.statusCode === 406) {
                    enqueueSnackbar("Templated message topic validation error", { variant: 'warning' });
                    //setServerErrors(res.data.errors);
                }
                else {
                    enqueueSnackbar("Error saving templated message topic", { variant: 'error' });
                }
            } finally {
            }
        })();
    }

    React.useEffect(() => {
        populateTopics();
        fetchLanguages();
    }, []);

    const fetchLanguages = async () => {
        console.debug("TemplatedMessagesMenu: fetching languages...")
    
        const dataAPI = props.dataAPI;
    
        (async () => {
          try {
            const res = await dataAPI(GET_LIST, "user/language_list_enabled_by_tour_op", {});
    
            if (res.statusCode === 200 || res.statusCode === 201) {
                console.log("fetchLanguages: Languages:", res)
                setLanguages(res.data)
            } else if (res.statusCode === 406) {
              console.warn("fetchLanguages: Validation error when fetching", res);
            }
            else {
              console.warn("fetchLanguages: Error fetching", res);
            }
          } finally {
            setState((prevState) => ({...prevState, syncActive: false}));
          }
        })();
    
      };

    const handleTemplatedMsgSave = (ev) => {
        const msgText = templateTextFieldRef.current.value;
        const msgTitle = templateTitleFieldRef.current.value;
        const topicName = templateTopicRef.current;

        if (!msgText || !msgText.trim()) {
            templateTextFieldRef.current.value = ""
            setState((prevState) => ({
                ...prevState,
                templatedMessageText: "",
                templatedMessageHasChangedSinceLastSave: false,
            }))
            return
        }

        if (!msgTitle || !msgTitle.trim()) {
            templateTitleFieldRef.current.value = ""
            setState((prevState) => ({
                ...prevState,
                templatedMessageTitle: "",
                templatedMessageHasChangedSinceLastSave: false,
            }))
            return
        }

        (async () => {
            try {

                const res = await dataAPI(isCreating ? CREATE : UPDATE, resource, {
                    id: isCreating ? null : msgBeingEdited.id,
                    data: {
                        language: templateLanguageRef.current,
                        title: msgTitle,
                        text: msgText,
                        topic: topicName
                    }
                });

                if (res.statusCode === 200 || res.statusCode === 201) {
                    enqueueSnackbar("Templated message saved", { variant: 'success' });
                    //var updatedTemplatedMessagesList = [res.data].concat(state.templatedMessagesList)
                    templateTextFieldRef.current.value = ""
                    templateTitleFieldRef.current.value = ""
                    templateTopicRef.current = ""
                    setState((prevState) => ({
                        ...prevState,
                        templatedMessageText: "",
                        templatedMessageTitle: "",
                        templatedMessageLanguage: "",
                        templatedMessageTopic: "",
                        templatedMessageHasChangedSinceLastSave: false,
                        //numTemplatedMessages: state.numTemplatedMessages + 1,
                        //templatedMessagesList: updatedTemplatedMessagesList
                    }))
                    populateTopics();
                    setIsCreating(false);
                    setIsEditing(false);
                    console.log("Templated messages list:", state.templatedMessagesList)
                } else if (res.statusCode === 406) {
                    enqueueSnackbar("Templated message validation error", { variant: 'warning' });
                    //setServerErrors(res.data.errors);
                }
                else {
                    enqueueSnackbar("Error saving templated message", { variant: 'error' });
                }
            } finally {
                //this.setState({ syncActive: false });
            }
        })();
    }

    const onLanguageChange = (ev, lang, reason) => {
        console.log('lang change', lang);
        templateLanguageRef.current = lang?.id.toUpperCase();
        setState((prevState) => ({ ...prevState, templatedMessageLanguage: lang?.id || prevState.templatedMessageLanguage}));
        checkHasChanged()
    };

    const onTopicChange = (ev, topic, reason) => {
        console.log('topic change', topic);
        templateTopicRef.current = topic?.name || topic?.title;
        setState((prevState) => ({ ...prevState, templatedMessageTopic: templateTopicRef.current || prevState.templatedMessageTopic}));
        checkHasChanged()
    };

    const onQueryChange = (query) => {
        setQuery(query);
    };

    const handleExportCSV = async () => {
        try {
            setRelatedLoading(true);
            const params = {
                filter: {
                    query: query,
                    filters: JSON.stringify([...(APIFilters || [])]),
                },
                urlSuffix: "export/",
            };
            console.log('onExportList:', params);

            console.log('onExportList: requesting data', params);
            const res = await dataAPI(GET_ONE, templated_chat_messages_list_resource, params);
            const body = await res.response.blob();
            console.log('onExportList: got response', body);
            const url = window.URL.createObjectURL(body);

            var filename = "";
            const disposition = res.headers['Content-Disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (!filename || filename.length <= 0) {
                filename = "templated_messages.csv";
            }
            console.log('onExportList: downloading as file', filename, url);

            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("onExportList: Error exporting list:", error);
        } finally {
            setRelatedLoading(false);
        }
    }

    const getAISuggestedResponse = async () => {
        try {
            setRelatedLoading(true);
            setIsWaitingForAIResponse(true);

            const u_id = String(JSON.parse(window.localStorage.getItem('bootstrap'))?.user['id'])
            let params = { conversation_unique_name: props.conversation_unique_name, user_id: u_id }
            const response = await axios.post(`${config.apiUrl}/chat/get_custom_ai_response/`, params, reqConfig())
        
            const { data } = response;
            
            console.log("getAISuggestedResponse: Response:", data);
            handleRowClick(data['ai_response'])
        } catch (error) {
            console.error("getAISuggestedResponse: Error getting response:", error);
        } finally {
            setIsWaitingForAIResponse(false);
            setRelatedLoading(false);
        }
    }

    return (
        <div style={{ position: "absolute", width: "98%", right: 0, height: "100%", border: `1px solid ${cv('border', 'rgb(224, 224, 224)')}`, backgroundColor: cv('surface', "white"), zIndex: 11, padding: "2%", borderRadius: "16px" }} >

                    {!isCreating && !isEditing && !isViewingTopics ?
                        <div>
                            <div style={{ fontWeight: 600, marginLeft: 10, marginBottom: 15}}>
                                {// weird bug whereby typing the first character of the first element loses focus and creates a weird
                                    // border in the UI. Using a junk character as a workaraound
                                }
                                <div style={{marginTop: 5, marginBottom: 10, position: "relative", zIndex: 12}}>Templates</div>
                                <span style={{ position: "absolute", right: 0, marginTop: 0, fontSize: ".01rem", color: cv('surface', "white") }}>★</span>
                                <span style={{ position: "absolute", left: 0, top: 0, height: "85px", width: "100%", backgroundColor: cv('surface-muted', "#F5F5F5"), borderRadius: "15px 15px 0px 0px" }}></span>

                                
                                <span onClick={e => props.closeTemplatedMessagesPane()} style={props.styles.closeButton}>&times;</span>
                                <div style={{ marginBottom: 14 }}>
                                    {canWriteTemplates &&
                                    <Button
                                        style={{ backgroundColor: cv('accent-fill', "#007AFF") }}
                                        variant="contained"
                                        size="small"
                                        disableElevation
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (templateTextFieldRef.current) templateTextFieldRef.current.value = "";
                                            templateTextRef.current = "";
                                            if (templateTitleFieldRef.current) templateTitleFieldRef.current.value = "";
                                            templateTitleRef.current = "";
                                            templateLanguageRef.current = props.subjectUserLanguage;
                                            templateTopicRef.current = null;
                                            setIsCreating(true);
                                        }}>CREATE
                                    </Button>
                                    }
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        style={{ color: cv('accent', "#007AFF"), marginLeft: 10 }}
                                        onClick={handleExportCSV}
                                    >
                                        Export
                                    </Button>
                                </div>
                            </div>

                            <TemplatedMessagesMenuToolbar
                                onQueryChange={onQueryChange}
                                apiFilters={APIFilters}
                                setAPIFilters={setAPIFilters}
                                selectedTopicFilter={selectedTopicFilter}
                                setSelectedTopicFilter={setSelectedTopicFilter}
                                selectedLanguageFilter={selectedLanguageFilter}
                                setSelectedLanguageFilter={setSelectedLanguageFilter}
                                topicOptions={topicOptions}
                                isSmallScreen={props.isSmallScreen}
                                query={query}
                                languages={languages}
                                subjectUserLanguage={props.subjectUserLanguage}
                                setIsCreating={setIsCreating}
                                setIsViewingTopics={setIsViewingTopics}
                            />

                            <RecordList
                                resource={templated_chat_messages_list_resource}
                                perPage={100}
                                rowHeight={80}
                                headerHeight={0}
                                checkboxSelection={false}
                                refreshFromBackendFunc={refreshFromBackendFunc}
                                hideQuickFilter={true}
                                query={query}
                                apiFilters={APIFilters}
                                hiddenAPIFilters={props.templatedMsgRefreshKey}
                                minHeight={showAISuggestionButton ? "calc(86vh - 290px)": "calc(86vh - 270px)"}
                                maxHeight={showAISuggestionButton ? "calc(86vh - 290px)": "calc(86vh - 270px)"}
                                headerDisplay={"none"}
                                rowsPerPageOptions={[]}
                                relatedLoading={relatedLoading}
                                columns={[
                                    {
                                        field: 'title', headerName: 'Title', sortable: false, flex: 5.00,
                                        renderCell: (p) => {
                                            return (
                                                <span style={{ display: "flex", width: "98%", marginTop: "6px", marginLeft: "6px" }} onClick={(e) => { handleRowClick(p.row.text) }}>
                                                    <Tooltip
                                                        // Open beside the row (over the chat area) rather than over the template
                                                        // list, so the preview never covers — and never blocks clicking — other
                                                        // rows. On small screens the panel is ~full-width and there's no room to
                                                        // the side (the tooltip lands off-screen), so open below the row instead.
                                                        // The arrow direction below keys off the resolved placement.
                                                        placement={props.isSmallScreen ? "bottom-start" : "left-start"}
                                                        // Fade (opacity only) instead of the default Grow (scale transform): Grow's
                                                        // transform settling is what makes the tooltip/arrow visibly "jump".
                                                        TransitionComponent={Fade}
                                                        // Only preview after a deliberate hover pause, so the box doesn't pop up
                                                        // (and cover things) while just moving through / scrolling the list.
                                                        // enterNextDelay keeps the pause when sliding row-to-row too.
                                                        enterDelay={500}
                                                        enterNextDelay={500}
                                                        // strategy:fixed so a tall tooltip can't extend the document scroll height
                                                        // (which pops a window scrollbar and jerks the page). preventOverflow altAxis
                                                        // clamps the horizontal axis too, so a wide tooltip on a narrow window shifts
                                                        // left to stay on-screen instead of being cut off at the right.
                                                        PopperProps={{
                                                            popperOptions: { strategy: 'fixed' },
                                                            modifiers: [
                                                                { name: 'preventOverflow', options: { altAxis: true, padding: 8 } },
                                                                // If the preferred side doesn't fit (mid-size windows), fall back
                                                                // through these rather than rendering off-screen.
                                                                { name: 'flip', options: { fallbackPlacements: ['right-start', 'bottom-start', 'top-start'] } },
                                                            ],
                                                        }}
                                                        // Native title can't be styled; use MUI Tooltip so the template name renders bold.
                                                        // Cap the height so a long message scrolls inside the tooltip instead of
                                                        // running off-screen (box stays overflow:visible for the arrow, so scroll
                                                        // lives on this inner block). On small screens the tooltip sits over the
                                                        // list, so clamp to ~12 lines with an ellipsis instead of a tall scroller.
                                                        title={<span style={props.isSmallScreen
                                                            ? { display: '-webkit-box', WebkitLineClamp: 12, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-wrap' }
                                                            : { display: 'block', maxHeight: '70vh', overflowY: 'auto', whiteSpace: 'pre-wrap' }}><b>{p.row.title}</b>{`\n\n${p.row.text}`}</span>}
                                                        // MUI's built-in arrow points at the (wide) row's center, so it drifts right
                                                        // and detaches on narrow tooltips. Draw our own left-anchored arrow via a
                                                        // ::before triangle instead, flipping its direction with the popper placement.
                                                        componentsProps={{
                                                            popper: {
                                                                sx: {
                                                                    '& .MuiTooltip-tooltip': { overflow: 'visible', position: 'relative' },
                                                                    // Thin, subtle scrollbar on the inner scroll block.
                                                                    '& .MuiTooltip-tooltip > span': {
                                                                        scrollbarWidth: 'thin',
                                                                        scrollbarColor: 'rgba(255,255,255,0.4) transparent',
                                                                        '&::-webkit-scrollbar': { width: '6px' },
                                                                        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(255,255,255,0.4)', borderRadius: '3px' },
                                                                        '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
                                                                    },
                                                                    // Overlap the arrow base 1px into the box (top/bottom: -5 for a 6px
                                                                    // triangle) so the grow-transition settle can't expose a hairline seam.
                                                                    '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip::before': {
                                                                        content: '""', position: 'absolute', top: -5, left: 16, width: 0, height: 0,
                                                                        borderLeft: '6px solid transparent', borderRight: '6px solid transparent',
                                                                        borderBottom: '6px solid rgba(97, 97, 97, 0.92)',
                                                                    },
                                                                    '&[data-popper-placement*="top"] .MuiTooltip-tooltip::before': {
                                                                        content: '""', position: 'absolute', bottom: -5, left: 16, width: 0, height: 0,
                                                                        borderLeft: '6px solid transparent', borderRight: '6px solid transparent',
                                                                        borderTop: '6px solid rgba(97, 97, 97, 0.92)',
                                                                    },
                                                                    // Side placements: arrow on the vertical edge facing the row.
                                                                    '&[data-popper-placement*="left"] .MuiTooltip-tooltip::before': {
                                                                        content: '""', position: 'absolute', right: -5, top: 12, width: 0, height: 0,
                                                                        borderTop: '6px solid transparent', borderBottom: '6px solid transparent',
                                                                        borderLeft: '6px solid rgba(97, 97, 97, 0.92)',
                                                                    },
                                                                    '&[data-popper-placement*="right"] .MuiTooltip-tooltip::before': {
                                                                        content: '""', position: 'absolute', left: -5, top: 12, width: 0, height: 0,
                                                                        borderTop: '6px solid transparent', borderBottom: '6px solid transparent',
                                                                        borderRight: '6px solid rgba(97, 97, 97, 0.92)',
                                                                    },
                                                                },
                                                            },
                                                            tooltip: { sx: { maxWidth: 'min(520px, calc(100vw - 16px))', fontSize: '0.8rem', backgroundColor: 'rgba(97, 97, 97, 0.92)' } },
                                                        }}
                                                    >
                                                        <span style={{ flex: 5, overflow: 'hidden', minWidth: 0, marginRight: "20px" }}>
                                                            <div style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', wordBreak: 'break-word' }}>
                                                                <b>{p.row.title}</b>&nbsp;
                                                                <span style={{ backgroundColor: cv('surface-strong', "#D8D8D8"), padding: "3px 5px 3px 5px", borderRadius: "15px", whiteSpace: 'nowrap' }}>{p.row.language}</span>
                                                            </div>
                                                            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{p.row.text}</div>
                                                        </span>
                                                    </Tooltip>
                                                    <span style={{ verticalAlign: "middle", flex: 1, marginTop: "auto", marginBottom: "auto", marginLeft: "auto" }}>
                                                        {canWriteTemplates &&
                                                        <IconButton onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (templateTextFieldRef.current) templateTextFieldRef.current.value = p.row.text;
                                                            templateTextRef.current = p.row.text;
                                                            if (templateTitleFieldRef.current) templateTitleFieldRef.current.value = p.row.title;
                                                            templateTitleRef.current = p.row.title;
                                                            templateLanguageRef.current = p.row.language;
                                                            templateTopicRef.current = p.row.topic
                                                            setMsgBeingEdited(p.row)
                                                            setIsEditing(true);
                                                        }}>
                                                            <EditIcon style={{ color: cv('accent', '#007AFF') }} />
                                                        </IconButton>
                                                        }
                                                        <DeleteIconButton
                                                            perm="chat_template.delete"
                                                            size="medium"
                                                            fontSize="medium"
                                                            onClick={(e) => { e.stopPropagation(); props.handleDeleteTemplatedMsg(p.row.id) }}
                                                        />
                                                    </span>
                                                </span>
                                            );
                                        },
                                    },
                                ]
                                }
                            />
                            {showAISuggestionButton &&
                            <Button
                                variant="outlined"
                                size="small"
                                style={{marginTop: 10 }}
                                disabled={isWaitingForAIResponse}
                                onClick={getAISuggestedResponse}
                            >
                                {!isWaitingForAIResponse ? "Suggest a response" : "Thinking..."}
                            </Button>
                            }
                        </div>
                        : isCreating || isEditing ?
                            // CP-7990: keep the header fixed and scroll only the form body below it, so a
                            // long message (the message field is multiline with no maxRows) no longer
                            // overflows the fixed-height panel or scrolls under the header overlay.
                            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                                <div style={{ position: "relative", flexShrink: 0, height: "50px", marginBottom: 8, display: "flex", alignItems: "center", backgroundColor: cv('surface-muted', "#F5F5F5"), borderRadius: "15px 15px 0px 0px", zIndex: 12 }}>
                                    <NavigateBefore style={{ cursor: "pointer", marginLeft: 4 }} onClick={(e) => { e.stopPropagation(); handleGoBack() }} />
                                    <b>&nbsp;&nbsp;
                                        <span style={{ position: "absolute", right: 0, marginTop: 0, fontSize: ".01rem", color: cv('surface', "white") }}>★</span>
                                        {isCreating ? <span>Create New </span> : <span>Edit</span>}&nbsp;Template
                                    </b>
                                    <span onClick={e => handleClose()} style={props.styles.closeButton}>&times;</span>
                                </div>

                                <div style={{ flex: 1, minHeight: 0, overflowY: "auto", display: "flex", flexDirection: "column" }}>
                                <TextField
                                    style={{ color: "#F5F5F5", margin: 10 }}
                                    label="Name"
                                    variant="filled"
                                    size="small"
                                    inputRef={templateTitleFieldRef}
                                    defaultValue={templateTitleRef.current}
                                    onChange={checkHasChanged}
                                >
                                </TextField>
                                <Grid container direction="row" style={{ color: "#F5F5F5" }}>
                                    <Grid item xs={12} sm={7} style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                        <Autocomplete
                                            options={topicOptions}
                                            value={templateTopicRef.current ? { "name": templateTopicRef.current } : null}
                                            noOptionsText={topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.toUpperCase()) === -1 ? `Press Enter to add "${topicInputValue}"` : null}
                                            getOptionLabel={(option) => option.title || option.name}
                                            onInputChange={(e, newValue) => {
                                                setTopicInputValue(newValue.trim());
                                            }}
                                            onChange={onTopicChange}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={topicInputValue.trim() && topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.toUpperCase()) === -1 ? `Pressing Enter will add \"${topicInputValue}\"` : "Topic"}
                                                    variant="filled"
                                                    size="small"
                                                    //helperText="Enter to add new"
                                                    onKeyDown={(e) => {
                                                        if (
                                                            e.key === "Enter" && topicInputValue.trim() &&
                                                            topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.toUpperCase()) === -1
                                                        ) {
                                                            setTopicOptions((o) => o.concat({ name: topicInputValue }));
                                                            templateTopicRef.current = topicInputValue;
                                                            setState((prevState) => ({ ...prevState, templatedMessageTopic: templateTopicRef.current || prevState.templatedMessageTopic }));
                                                            handleTemplatedMsgTopicSave(topicInputValue)

                                                        }
                                                        else if (e.key == 'ArrowDown' || e.key == 'ArrowUp'){
                                                            e.stopPropagation()
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={5} style={{ paddingLeft: props.isSmallScreen ? "10px" : null, paddingTop: props.isSmallScreen ? "10px" : null, paddingRight: "10px" }}>
                                        <Autocomplete
                                            options={languages}
                                            getOptionLabel={(opt) => opt.name ?? opt}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Language"
                                                    variant="filled"
                                                    size="small"
                                                />
                                            )}
                                            fullWidth
                                            onChange={onLanguageChange}
                                            value={languages.find((element) => element.id?.toUpperCase() === templateLanguageRef.current?.toUpperCase()) ?? templateLanguageRef.current?.toUpperCase()}
                                        />
                                    </Grid>
                                </Grid>
                                <TextField
                                    style={{ color: "#F5F5F5", margin: 10 }}
                                    label="Write a message"
                                    variant="filled"
                                    multiline
                                    minRows={10}
                                    inputRef={templateTextFieldRef}
                                    defaultValue={templateTextRef.current}
                                    onChange={checkHasChanged}
                                >
                                </TextField>
                                <FormActionButtons
                                    mode={isCreating ? 'create' : 'edit'}
                                    sx={{ mx: 1.25, mt: 0.5, mb: 1.25 }}
                                    submitDisabled={!state.templatedMessageIsSavable || !canWriteTemplates}
                                    onSubmit={(e) => { e.stopPropagation(); handleTemplatedMsgSave() }}
                                    onCancel={(e) => { e.stopPropagation(); handleGoBack() }}
                                />
                                </div>
                            </div>
                            :
                            <TemplatedMessageTopicsMenu
                                handleGoBack={handleGoBack}
                                populateTopics={populateTopics}
                                topicOptions={topicOptions}
                                setTopicOptions={setTopicOptions}
                                setState={setState}
                                updateTemplatedMsgRefreshKey={props.updateTemplatedMsgRefreshKey}
                                templatedMsgRefreshKey={props.templatedMsgRefreshKey}
                                handleDeleteTemplatedMsgTopic={props.handleDeleteTemplatedMsgTopic}
                                handleTemplatedMsgTopicSave={handleTemplatedMsgTopicSave}
                                closeTemplatedMessagesPane={props.closeTemplatedMessagesPane}
                                styles={props.styles}
                            />
                    }
        </div>
    );
}
